export const PRODUCT_ID_QUERY = `query getProductByID($id: ID!) {
  product(id: $id) {
      ... on ContentInterface {
        id
        title
        created
        modified
        status
        featured
        sticky
        path
        order
        access
        type
      }
      ... on ProductInterface {
        producttype
        productsettings {
          discountgroup
          managestock
          sku
          stock
          price
          prices {
            base_price
            unit_price
            role_adjust_prices {
              rbdid
              roleid
              adjustment
              label
              weight
              txntype
              amount
            }
          }
          allowincart
          allowinpos
          showincatalog
          cartmultiple
          customqty
        }
        abstract
        images {
          image {
            filepath
            filesize
            filemime
            preset
            filestorename
            data {
              alt
              title
            }
          }
        }
      }
      ...on GenericProductType {
        seo {
          titletag
          metadesctag
          path
        }
      }
      ...on POSProduct {
        body
        posProductCategory: category
        seo {
          titletag
          metadesctag
          path
        }
      }
      ... on POSFoodProduct {
        body
        posFoodProductCategory: category
        seo {
          titletag
          metadesctag
          path
        }
      }
      ... on POSModifierProduct {
        body
        posModifierProductCategory: category
        seo {
          titletag
          metadesctag
          path
        }
      }
      ... on SomnambulistSelection {
        seo {
          titletag
          metadesctag
          path
        }
      }
      ... on VCShopProduct {
        pack_size
        shopProductCategory: category
        body
        seo {
          titletag
          metadesctag
          path
        }
        award_winner, bottlesize, bottlesize_icon, wineproductrrp: rrp, unit_of_sale
        reviews { title, subtitle, review, points, date }, awards { title, subtitle, level, year }, features { title, text },
        related_products { delta, product { id, title } }
        product_links_name
        product_links { delta, link { title, url } }
      }
      ... on WineProduct {
        body
        seo {
          titletag
          metadesctag
          path
        }
        producer {
          id
          name
          liquor_license
          min_cart_qty
          cart_qty_divisor
          rates {
            label
            type
            rate
            value
            qty
            delta
          }
        }
        award_winner, varietal, varietal_icon, bottlesize, bottlesize_icon, vintage, winebody, winebody_icon, wine_type, wine_type_icon, brand, region, attributes, collections, sweetness, series, seo { path }, wineproductrrp: rrp, faq_categories, unit_of_sale
        tasting_notes { title, text }, wine_making { title, text }, technical_notes { title, text }, reviews { title, subtitle, review, points, date }, awards { title, subtitle, level, year }, features { title, text },
        prev_tasting_notes { delta, file { data { title }, preview_url, filestorename, filepath, preset } }
        wine_club, max_cart, max_club, min_club, pack_size
        related_products { delta, product { id, title } }
        product_links_name
        product_links { delta, link { title, url } }
      }
      ... on WineGlassProduct {
        body
        seo {
          titletag
          metadesctag
          path
        }
        varietal
        wine_type
        sweetness
        series
        wineglassproductrrp: rrp
        unit_of_sale
      }
      ... on WineTastingProductType {
        body
        seo {
          titletag
          metadesctag
          path
        }
        unit_of_sale
      }
  }
}`
